import { SET_USER_TYPING } from "../actions/typingActions";

const initialState = {
  typingUsers: {} // { matchId: { userId: true/false } }
};

export default function typingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_TYPING: {
      const { matchId, userId, isTyping } = action.payload;
      return {
        ...state,
        typingUsers: {
          ...state.typingUsers,
          [matchId]: {
            ...(state.typingUsers[matchId] || {}),
            [userId]: isTyping
          }
        }
      };
    }

    default:
      return state;
  }
}
